import { isEmpty } from './isEmpty';

export const getAccountNameOrFullName = (account: string, firstName: string, lastName: string) => {
  const fullName = `${firstName} ${lastName}`.trim();

  return isEmpty(fullName) ? account : `${account} (${fullName})`;
};
